import React from 'react';
import { Typography } from 'seagull';
import styles from "./BrandPreview.module.scss";
export const BrandPreview = props => {
  const {
    logoImage
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.image
  }, logoImage && /*#__PURE__*/React.createElement("img", {
    alt: "Logo",
    src: logoImage,
    "data-testid": "onboarding-widget-brand-preview-logo"
  })), /*#__PURE__*/React.createElement(Typography, {
    className: styles.title,
    variant: "paragraph3",
    weight: "normal",
    skin: "secondary"
  }, "Dear client"), /*#__PURE__*/React.createElement("div", {
    className: styles.block,
    style: {
      width: '60%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.block,
    style: {
      width: '75%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.separator
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.block,
    style: {
      width: '90%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.block,
    style: {
      width: '35%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.block,
    style: {
      width: '65%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.block,
    style: {
      width: '55%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.block,
    style: {
      width: '95%'
    }
  }));
};